// shopifyClient.js
import Client from "shopify-buy";

const client = Client.buildClient({
  domain: "obidevdemo.myshopify.com",
  storefrontAccessToken: "196e90892c8fffd3bb5c0518b3587d99",
});
export default client;
